import { render, staticRenderFns } from "./LoginPasswordResetModal.vue?vue&type=template&id=9bdf8372&"
import script from "./LoginPasswordResetModal.vue?vue&type=script&lang=ts&"
export * from "./LoginPasswordResetModal.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPasswordResetModal.vue?vue&type=style&index=0&id=9bdf8372&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports